module.exports = __webpack_public_path__ + "img/tz2.2da3cb83.png";